import { FC } from "react";
import { Button } from "@design-system/Button/Button";
import { WithHotkey } from "@design-system/Button/WithHotkey";
import { LeftArrowIcon } from "@icons";
import containerStyles from "../../AddClientDrawerStepsContainer.module.scss";

interface Props {
    onBack: () => void;
    onNext: () => void;
    isNextEnabled: boolean;
}

export const SetupStepFooter: FC<Props> = ({
    onBack,
    onNext,
    isNextEnabled,
}) => (
    <div className={containerStyles.footer}>
        <Button
            variant="primary"
            type="button"
            onClick={onBack}
            iconOnly
            size="xl"
            aria-label="Go back"
        >
            <LeftArrowIcon />
        </Button>

        <WithHotkey
            hotKey="mod+enter"
            hotKeyDisplayPosition="inline"
            hotKeyOptions={{
                description: "Next",
                enabled: isNextEnabled,
                preventDefault: true,
                enableOnFormTags: true,
            }}
        >
            {(hotkeyHint) => (
                <Button
                    variant="primary"
                    type="button"
                    onClick={() => onNext()}
                    size="xl"
                    disabled={!isNextEnabled}
                    rightIcon={hotkeyHint}
                >
                    Next
                </Button>
            )}
        </WithHotkey>
    </div>
);
